<template>
  <div class="search-input">
    <div :class="getSearchInputPosition" class="search-input-wrapper-out">
      <div :class="getSearchInputPosition" class="search-input-wrapper-in">
        <form :class="getSearchInputPosition" class="search-form form" @submit.prevent="onSubmit">
          <a class="form-icon search">
            <i class="material-icons">
              search
            </i>
          </a>
          <input v-model="keyword" v-focus :placeholder="placeholder" :disabled="disabled" aria-label="Search input" type="text" maxlength="50" class="form-input" @focus="showSuggestion = true">
          <a class="form-icon forward" @click="onSubmit">
            <i class="material-icons">
              arrow_forward
            </i>
          </a>
        </form>
        <slot />
      </div>
    </div>
    <SearchAutocomplete
      v-if="getSearchInputPosition === 'relative' && ($production.toUpperCase() !== 'AIR' && $production.toUpperCase() !== '')"
      :class="{'active': showSuggestion && keyword && keyword.length > 1}"
      :keyword="keyword"
      @update="searchKeyword"
    />
  </div>
</template>

<script>
import SearchAutocomplete from '@/components/search/SearchAutocomplete'

export default {
  name: 'SearchInput',
  components: {
    SearchAutocomplete
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      }
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: '',
      showSuggestion: false
    }
  },
  computed: {
    getSearchedKeyword() {
      return this.$store.state.search.keyword
    },
    getSearchInputPosition() {
      return this.$store.state.search.inputPosition
    },
    placeholder() {
      return this.$t('SEARCH.PLACEHOLDER')
    }
  },
  watch: {},
  created() {
    this.keyword = this.getSearchedKeyword
    if (this.$route.query.q) {
      // auto query
      // console.log('Auto query keyword', this.$route.query.q)
      this.keyword = this.$route.query.q
      this.onSubmit()
    }
  },
  mounted() {},
  updated() {},
  methods: {
    onSubmit() {
      this.$emit('submit', this.keyword.replace(/\//g, ''))
      this.showSuggestion = false
    },
    searchKeyword(keyword, type) {
      this.keyword = keyword
      this.$emit('update', type, this.keyword && this.keyword.replace(/\//g, ''))
      // this.$emit('submit', this.keyword && this.keyword.replace(/\//g, ''))
      this.showSuggestion = false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

$form-height: 64px;
.search-input {
  position: relative;
}
.search-input-wrapper-out {
  position: relative;
  margin-top: 60px;
  min-height: 64px;
  width: 100%;
  overflow: hidden;
  z-index: 1;
}

.search-input-wrapper-in {
  .cancel {
    height: 64px;
    > i {
      margin: 14px 0;
      font-size: 36px;
      color: $grey-7d;
      vertical-align: middle;
      cursor: pointer;

      &:hover {
        color: $link-hover;
      }
    }
    &:not(.fixed) {
      display: none;
    }
    &.fixed {
      display: inline-block;
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  &.fixed {
    position: fixed;
    top: 0;
    margin: 0 auto;
    width: calc(1440px - 72px - 136px);
    // max-width: 1440px;
    // padding-bottom: 16px;
    background-color: #ffffff;
  }
}

.form {
  position: relative;
  display: block;
  height: $form-height;
  width: 100%;
  background-color: #ffffff;
  border-bottom: 1px solid $grey-7d;
  transition: width 0.3s linear;
  &-icon {
    position: absolute;
    display: inline-block;
    width: 36px;
    height: $form-height;
    color: $grey-7d;
    > i {
      margin: 14px 0;
      font-size: 36px;
    }
    &.search {
      top: 0;
      left: 0;
      text-align: left;
    }
    &.forward {
      top: 0;
      right: 0;
      text-align: right;
      cursor: pointer;
    }
  }
  &-input {
    position: absolute;
    left: 36px;
    width: calc(100% - 72px);
    height: $form-height;
    padding: 0 24px;
    font-size: 36px;
    font-weight: 500;
    color: $grey-50;
    background: none;
    outline: none;
    border: none;
    caret-color: $theme-yellow;
    &::placeholder {
      color: $grey-ec;
    }
    &:disabled {
      cursor: not-allowed;
    }
  }
  &.fixed {
    display: inline-block;
    vertical-align: top;
    width: 593px;
    margin-right: 48px;
  }
}
@media only screen and (min-width: 1440px) {
}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .search-input-wrapper-in {
    &.fixed {
      width: calc(100% - (36px * 2) - (12px * 2));
    }
  }
  .form {
    &.fixed {
      width: 370px;
    }
  }
}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  $form-sm-height: 56px;
  .search-input {
    margin-top: 0;
  }
  .search-input-wrapper-out {
    margin-top: 0;
  }
  .search-input-wrapper-in {
    .cancel {
      height: 56px;
      > i {
        margin: 16px 0;
        font-size: 24px;
      }
    }
    &.fixed {
      width: calc(100% - 72px);
    }
  }
  .form {
    height: $form-sm-height;
    &-icon {
      width: 24px;
      height: $form-sm-height;
      > i {
        margin: 16px 0;
        font-size: 24px;
      }
    }
    &-input {
      left: 24px;
      width: calc(100% - 72px);
      height: $form-sm-height;
      padding: 0 16px;
      font-size: 24px;
    }

    &.fixed {
      width: 280px;
    }
  }
}
@media only screen and (max-width: 767.98px) {
  $form-xs-height: 44px;
  .search-input {
    margin-top: 0;
  }
  .search-input-wrapper-out {
    margin-top: 0;
  }
  .search-input-wrapper-in {
    .cancel {
      height: 44px;
      > i {
        margin: 10px 0;
        font-size: 24px;
      }
    }
    &.fixed {
      width: calc(100% - 48px);
    }
  }
  .form {
    height: $form-xs-height;
    margin: 0;
    &-icon {
      width: 24px;
      height: $form-xs-height;
      > i {
        margin: 10px 0;
        font-size: 24px;
      }
    }
    &-input {
      left: 24px;
      width: calc(100% - 48px);
      height: $form-xs-height;
      padding: 0 8px; // 0 16px ???
      font-size: 18px;
    }
    &.fixed {
      width: 180px;
    }
  }
}
</style>
